import type { FormField } from '../../types';
import { FormFieldWrapper } from './FormFieldWrapper';

interface AddressValue { line1?: string; line2?: string; city?: string; postcode?: string; }
interface Props { field: FormField; value: unknown; onChange: (v: unknown) => void; error?: string; }
export function AddressField({ field, value, onChange, error }: Props) {
  const addr = (value as AddressValue) ?? {};
  const update = (key: keyof AddressValue, val: string) => onChange({ ...addr, [key]: val });
  return (
    <FormFieldWrapper field={field} error={error}>
      <div className="address-grid">
        <input className="full-width" placeholder="Address line 1" value={addr.line1 ?? ''} onChange={e => update('line1', e.target.value)} />
        <input className="full-width" placeholder="Address line 2 (optional)" value={addr.line2 ?? ''} onChange={e => update('line2', e.target.value)} />
        <input placeholder="City" value={addr.city ?? ''} onChange={e => update('city', e.target.value)} />
        <input placeholder="Postcode" value={addr.postcode ?? ''} onChange={e => update('postcode', e.target.value)} />
      </div>
    </FormFieldWrapper>
  );
}
